import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";
import "./lib/analytics"; // Initialize analytics auto-tracking

createRoot(document.getElementById("root")!).render(<App />);
